import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { PublicHealthStepParams } from './types'
import { includeKidsSchema } from './types'

export const includeKids = (params: PublicHealthStepParams) => {
  const schema = includeKidsSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_publicHealth:steps.include_kids.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('include_kids'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'login',
    subFlow: SubFlow.PublicHealth,
  } as const satisfies AnyStepConfiguration
}
